<template>
	<layout>
		<template slot="left">
			<publicMenu :list="list" iconUrl="list"></publicMenu>
		</template>
		<template slot="right">
			<router-view></router-view>

			<!-- <keep-alive>
				
			</keep-alive> -->

		</template>
	</layout>
</template>

<script>
import layout from "../../components/layout.vue"
import publicMenu from "../../components/publicMenu.vue"
export default {
	components: {
		layout,
		publicMenu
	},
	data() {
		return {
			list: []
		}
	},
	watch: {
		$route(to, from) {
			if (to.path == "/index/rz") {
				this.$router.push(this.list[0].children[0].path);
			}
		}
	},
	created() {
		var a = JSON.parse(localStorage.getItem("cd"))
		a.forEach(val => {
			if (val.meta.title == '认证') {
				var b = val.children
				this.list = this.list.concat(b)
			}
		})
		if (this.$route.path == '/index/rz') {
			this.$router.push(this.list[0].children[0].path);
		}
		return

	}
}
</script>

<style>

</style>